export default __webpack_public_path__ + "static/auto-layout-do-dark-3c9b97207e22ab482b6fdea9f6a3cb4618af1d7d40e342bae55f4a1b2ad12c64.png";